import { FacilityTime } from "@etechinc/smartview-core";
import { cloudApi } from "./cloudApi";

export const facilityTimeApi = cloudApi.injectEndpoints({
  endpoints: (builder) => ({
    getFacilityTime: builder.query<FacilityTime, { jobNumber: string }>({
      query: ({ jobNumber }) => `/facility-time/${jobNumber}`,
      keepUnusedDataFor: 300, // 5 minutes
    }),
  }),
});

export const {
  useGetFacilityTimeQuery,
} = facilityTimeApi;